import {Subscription} from "rxjs";
import {AfterContentInit, Component, inject, NgZone, OnDestroy, OnInit, PLATFORM_ID} from '@angular/core';

import PhotoSwipe from "photoswipe";

import PhotoSwipeLightbox from "photoswipe/lightbox";
import {ImageViewerService} from "@numizmat/services/common";
import {ImageViewerItem} from "@numizmat/services-models/common";
import {isPlatformBrowser, isPlatformServer} from "@angular/common";

@Component({
  selector: 'nz-image-viewer',
  standalone: true,
  imports: [],
  templateUrl: './image-viewer.component.html',
  styleUrl: './image-viewer.component.scss'
})
export class ImageViewerComponent implements OnInit, AfterContentInit, OnDestroy {
  private ngZone: NgZone = inject(NgZone);
  private platformId: Object = inject(PLATFORM_ID);
  private imageViewerService: ImageViewerService = inject(ImageViewerService);

  private subs: Subscription = new Subscription();
  private lightbox: PhotoSwipeLightbox | undefined = undefined;

  protected images: ImageViewerItem[] = [];

  public ngOnInit(): void {
    if (isPlatformServer(this.platformId)) {
      return;
    }
    const subscription: Subscription = this.imageViewerService.getImages().subscribe({
      next: images => {
        if (!!images && images.length > 0) {
          this.images = images;
          const galleryElement = document.getElementById('gallery');
          if (!!galleryElement) {
            galleryElement.innerHTML = '';
            this.images.forEach(image => {
              const link = document.createElement('a');
              link.href = image.url;
              link.setAttribute('data-pswp-width', image.width.toString());
              link.setAttribute('data-pswp-height', image.height.toString());
              link.target = '_blank';
              const img = document.createElement('img');
              img.src = image.url;
              link.appendChild(img);
              galleryElement.appendChild(link);
            });
          }
          if (this.lightbox) {
            this.lightbox.loadAndOpen(0);
          }
        }
      }
    });
    this.subs.add(subscription);
  }

  public ngAfterContentInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.ngZone.runOutsideAngular(() => {
        this.lightbox = new PhotoSwipeLightbox({
          gallery: '#gallery',
          children: 'a',
          pswpModule: PhotoSwipe,
        });
      });
    }
  }

  public ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
